import React, { useState, useEffect, useContext } from "react";
import { FormGroup, Col, Label, Input, Form, Row, NavLink, ListInlineItem, Dropdown, DropdownToggle, DropdownMenu, DropdownItem,
} from "reactstrap";
import SubHeader from "./SubHeader";
import Select from "react-select";
import { FaChevronDown, FaChevronRight, FaEdit,FaRedo } from "react-icons/fa";
import axios from "../../api/axios";
import { GlobalContext } from "../../App";
import { toast } from "react-toastify";
import { MDBBtn, MDBTable, MDBTableHead, MDBTableBody } from "mdb-react-ui-kit";
import projectPlaceholderImg from "../../assets/images/no-projects.png";
import HoverTooltip from "../../components/global/Tooltip";
import TopHeader from "./TopHeader";
import { BsChevronRight } from "react-icons/bs";
import { InfinitySpin } from "react-loader-spinner";
import { useNavigate, useLocation } from "react-router-dom";

function Milestones() {
  const navigate = useNavigate();
  const body = document.body;
  const mainPanel = document.querySelector(".main-panel");
  const maskBgOverlay = document.createElement("div");
  maskBgOverlay.id = "maskBgOverlay";
  maskBgOverlay.className = "maskBgOverlay";
  const location = useLocation();
  const { pathname } = location;
  const { rolexModuleData, user_id, serialSequence, roles,userProfile } =
    useContext(GlobalContext);
    const isSpecialAccess = rolexModuleData?.find( (data) => pathname === data?.description && data?.special === 1 )|| roles?.find((data1) => data1?.role_id === 1001) ? true : false;
  const params = new URLSearchParams(location.search);
  var param1 = params.get("param1")
    ? parseInt(atob(params.get("param1")))
    : null;
    var param2 = params.get("?param2")
    ? parseInt(atob(params.get("?param2")))
    : null;
  const [projectList, setProjectList] = useState([]);
  const [newProjectList, setNewProjectList] = useState([]);
  const [userDataList, setUserDataList] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const [modal, setModal] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [userStatus, setUserStatus] = useState("All");
  const [milestoneData, setMilestoneData] = useState({
    projectTitle: [],
    milestoneTitle: null,
    milestoneDesc: null,
    milestoneOwner: [],
    updateId: null,
    milestoneStatus: { label: "Active", value: "Active" },
    milestoneOwnerId: []
  });
  const [milestoneList, setMilestoneList] = useState([]);
  const [tempMilestoneList, setTempMilestoneList] = useState([]);
  const [filterMilestone, setFilterMilestone] = useState({
    milestoneId: "",
    milestoneTitle: "",
    projectTitle: "",
    createdBy: "",
  });
  const [tempProjectList, setTempProjectList] = useState([]);
  const [taskUserList, setTaskUserList] = useState([]);
  const [loading, setLoading] = useState(true); 
  // ................. expand collaspe product table...............................//
  const [productisOpen1, productsetIsOpen1] = useState(1);
  //................... End  expand collaspe product table..........................//
 // Handle Error
 const handleError = (error) => {
  setLoading(false);
  const statusCode = error.response ? error.response.status : null;
  let errorMessage = "An error occurred!";

  if (statusCode === 500) {
    errorMessage = "Internal Server Error!";
  } else if (statusCode === 404) {
    errorMessage = "Page Not Found!";
  }

  toast.error(errorMessage, {
    position: toast.POSITION.TOP_RIGHT,
    theme: "colored",
    autoClose: 2000,
  });
};
  // -------------------------------------------------------- Get Project List --------------------------------------
  const getProjectList = (projectList) => {
    setLoading(true);
    axios
      .get("/getProjectList")
      .then((response) => {
        const ProjectList =
          response?.data?.[0]?.project_data
            ?.filter(
              (data) =>
              (param1 ? data?.project_id === param1 :  (isSpecialAccess ||
              data?.project_owner_id === user_id ||
              parseInt(data?.createdBy) === user_id
                ? data
                : projectList?.includes(data?.project_id))) 
                &&
                !(
                  data?.project_status === "Inactive"
                )
            )
            ?.map((item) => ({
              label: item?.project_title,
              value: item?.project_id,
              projectOwner: item?.project_x_owner,
              projectStatus: item?.project_status,
            })) ?? [];
        setProjectList(ProjectList);
        setLoading(false);
      }).catch(handleError);
  };
  // -------------------------------------------------------- Get User Data --------------------------------------
  const getUserData = () => {
    setLoading(true);
    const UserListCriteria  = isSpecialAccess ? '' : userProfile || '';
    axios.get(`/getUserData?UserListCriteria=${JSON?.stringify(UserListCriteria)}`).then((response, error) => {
        const userProject = response?.data?.[0]?.user_data
          ?.filter((item) => item?.user_id === user_id)?.[0]
          ?.user_x_project?.filter((data) => data?.project_access === 1 || data?.createdBy === user_id)
          ?.map((data) => data?.project_id);
        const userList = response?.data?.[0]?.user_data
          ?.filter((item) => item?.user_id === user_id)?.[0]
          ?.user_x_milestone?.filter((data) => data?.milestone_access === 1 || data?.createdBy === user_id)
          ?.map((data) => data?.milestone_id);
          const TaskuserList = response?.data?.[0]?.user_data
          ?.filter((item) => item?.user_id === user_id)?.[0]
          ?.user_x_task?.filter((data) => data?.task_access === 1 || data?.createdBy === user_id)
          ?.map((data) => data?.task_id);
          setTaskUserList(TaskuserList);
        getProjectList(userProject);
        getMilestoneList(userList);
        setLoading(false);
      }).catch(handleError);
  };
  const UserDataList = (project_id) => {
    setMilestoneData({ ...milestoneData, projectTitle: project_id, milestoneTitle: null, milestoneDesc: null, milestoneOwner: [], milestoneStatus: { label: "Active", value: "Active" } });
    for (let i = 0; i < projectList?.length; i++) {
      if (projectList[i]?.value === project_id?.value) {
        const userDataList =
          projectList[i]?.projectOwner
            ?.filter((item) => item?.isActive === "1")
            ?.map((item) => ({ label: item?.user_data?.[0]?.name, value: item?.user_id })) ??
          [];
        setUserDataList(userDataList);
      }
    }
  };
  // ----------------------------------------------------------- Handle Close ---------------------------------------
  const handleClose = () => {
    setModal(false);
    setIsFilter(false);
    setMilestoneData({
      ...milestoneData,
      projectTitle: [],
      milestoneTitle: null,
      milestoneDesc: null,
      milestoneOwner: [],
      updateId: null,
      milestoneStatus: { label: "Active", value: "Active" },
      milestoneOwnerId: []
    });
    body.style.overflow = "";
    document.getElementById("maskBgOverlay").remove();
  };
  const toggleModal = () => {
    setIsFilter(false);
    setModal(!modal);
    body.style.overflow = "hidden";
    mainPanel.appendChild(maskBgOverlay);
  };
  const toggleFilter = () => {
    setIsFilter(true);
    setModal(!modal);
    body.style.overflow = "hidden";
    mainPanel.appendChild(maskBgOverlay);
  };
  // ------------------------------------------------------- Add Level 1 --------------------------------------------
  const postAddMilestone = (e) => {
    if (milestoneData?.projectTitle?.length <= 0) {
      e.preventDefault();
      toast.error("Project title is required!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (
      milestoneData?.milestoneTitle === null ||
      milestoneData?.milestoneTitle === ""
    ) {
      e.preventDefault();
      toast.error("Level 1 title is required!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (milestoneData?.milestoneOwner?.length <= 0) {
      e.preventDefault();
      toast.error("Select team members!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    }
    else if (!milestoneData?.milestoneOwnerId?.value) {
      e.preventDefault();
      toast.error("Please select owner first!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000
      });
    }
     else if (!milestoneData?.milestoneOwner?.some(owner => owner.value === milestoneData?.milestoneOwnerId?.value)) {
      e.preventDefault();
      toast.error("Please select owner in team members!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000
      });
    }
    else if (
      milestoneData?.milestoneDesc === null ||
      milestoneData?.milestoneDesc === ""
    ) {
      e.preventDefault();
      toast.error("Level 1 description is required!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else {
      const params = {
        milestoneData: milestoneData,
        user_id: user_id,
        milestoneId: serialSequence[1]?.project_seqence,
        userProfile:userProfile
      }
      axios
        .post("/postAddMilestone", params)
        .then((response) => {
          if (response.status === 202) {
            e.preventDefault();
            toast.error("Level 1 already exist!", {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored",
              autoClose: 2000,
            });
          } else {
            toast.success(
              `Level 1  ${
                milestoneData?.updateId != null ? "updated" : "created"
              } successfully!`,
              {
                position: toast.POSITION.TOP_RIGHT,
                theme: "colored",
                autoClose: 2000,
              }
            );
            handleClose();
            getUserData();
          }
        }).catch(handleError);
    }
  };
  // ------------------------------------------------------------- Get Level 1 List ---------------------------------
  const getMilestoneList = (milestoneList) => {
    setLoading(true);
    axios
      .post("/getMilestoneList")
      .then((response) => {
        const milestone = response?.data?.[0]?.milestone_data
          ?.sort((a, b) => (a.updatedDate < b.updatedDate ? 1 : -1))
          ?.filter((data) =>
          param2  ? param2 === data?.milestone_id :
          isSpecialAccess ||
            data?.project_master?.[0]?.project_owner_id === user_id ||
            parseInt(data?.createdBy) === user_id
              ? data
              : milestoneList?.includes(data?.milestone_id)
          );
        setMilestoneList(milestone);
        setTempMilestoneList(milestone);
        const ProjectList =
          milestone
            ?.filter(
              (obj, index, arr) =>
                arr.findIndex(
                  (o) =>
                    o.project_master?.[0]?.project_id ===
                    obj.project_master?.[0]?.project_id
                ) === index &&
                (param1 ? param1 === obj?.project_master?.[0]?.project_id : obj)
            )
            ?.map((item) => ({
              label: item?.project_master?.[0]?.project_title,
              value: item?.project_id,
              projectOwner: item?.project_x_owner,
              projectStatus: item?.project_master?.[0]?.project_status,
            })) ?? [];
        setNewProjectList(ProjectList);
        productsetIsOpen1(ProjectList?.[0]?.value);
        setTempProjectList(ProjectList);
        setLoading(false);
      }).catch(handleError);
  };

  // --------------------------------------------------- Update Project Level 1 -------------------------------------------
  const UptMilestone = (milestone_id) => {
    setModal(!modal);
    for (let i = 0; i < milestoneList?.length; i++) {
      if (milestoneList[i]?.milestone_id === milestone_id) {
        const OwnerList =
          milestoneList[i]?.milestone_x_owner?.map((item) => ({
            label: item?.user_data?.[0]?.name,
            value: item?.user_id,
          })) ?? [];
        setMilestoneData({
          ...milestoneData,
          projectTitle: {
            label: milestoneList[i]?.project_title,
            value: milestoneList[i]?.project_id,
            projectStatus: milestoneList[i]?.project_master?.[0]?.project_status,
          },
          milestoneTitle: milestoneList[i]?.milestone_title,
          milestoneDesc: milestoneList[i]?.milestone_decription,
          milestoneOwner: OwnerList,
          updateId: milestoneList[i]?.milestone_id,
          milestoneStatus: {
            label: milestoneList[i]?.milestone_status,
            value: milestoneList[i]?.milestone_status,
          },
          milestoneOwnerId: { label: milestoneList[i]?.milestone_owner?.[0]?.name, value: milestoneList[i]?.milestone_owner_id }
        });
        for (let j = 0; j < projectList?.length; j++) {
          if (projectList[j]?.value === milestoneList[i]?.project_id) {
            const userDataList =
              projectList[j]?.projectOwner
                ?.filter((item) => item?.isActive === "1")
                ?.map((item) => ({
                  label: item?.user_data?.[0]?.name,
                  value: item?.user_id,
                })) ?? [];
            setUserDataList(userDataList);
          }
        }
      }
    }
    body.style.overflow = "hidden";
    mainPanel.appendChild(maskBgOverlay);
  };
  // ---------------------------------------------------------- Project Status list --------------------------------------
  const milestoneStatusList = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];
  // -------------------------------------------------------- Filter Level 1 List --------------------------------------
  const filterMilestoneList = (clear) => {
    const filterProjects = tempProjectList?.filter((data) =>
        data?.label.includes(filterMilestone?.projectTitle)
    );
    setNewProjectList(filterProjects);

    const filterMilestones = tempMilestoneList?.filter(
        (data) =>
            (!filterMilestone?.milestoneId ||
                data?.milestone_code?.includes(filterMilestone.milestoneId) ||
                data?.milestone_title?.includes(filterMilestone.milestoneId)) &&
            (!filterMilestone?.createdBy ||
                data?.created_user?.[0]?.name?.includes(filterMilestone.createdBy))
    );

    setMilestoneList(filterMilestones);

    if (clear) {
        handleClose();
    }
};

  // ------------------------------------------------------- Clear Filter Field ------------------------------------------
  const ClearFilter = () => {
    setFilterMilestone({
      milestoneId: "",
      milestoneTitle: "",
      projectTitle: "",
      createdBy: "",
    });
    filterMilestoneList(false);
    setNewProjectList(tempProjectList);
    setMilestoneList(tempMilestoneList);
  };
  // ---------------------------------------------------------- Mantain Log History ------------------------------
  const postLogHistory = () => {
    const param = {
      user_id: user_id,
      module_name: "Level 1",
      operationPerformed: "navigate to Level 1 screen",
    };
    axios.post("/postLogHistory", param);
  };

  // -------------------------------------------------------- Use Effect -----------------------------------------
  useEffect(() => {
    getUserData();
    // postLogHistory();
  }, []);
 return (
  loading ? (
    <div className="loader">
    <InfinitySpin width="200" color="#D81159" />
  </div>
  ) :
    (<>
      <TopHeader
        breadCrumb={
          <>
            <li className="nav-item">
              <a onClick={() => navigate("/home")} className="nav-link">
                Home <BsChevronRight />
              </a>
            </li>
            <li className="nav-item">
              <a onClick={() => navigate("/project-detail")} className="nav-link">
                Projects <BsChevronRight />
              </a>
            </li>
            <li className="nav-item">
              <span>Milestones</span>
            </li>
          </>
        }
      />
      <SubHeader
        SubHeaderTitle="Status"
        ShowFilterIcon={true}
        openSidebar={modal}
        isFilter={isFilter}
        handleClose={handleClose}
        toggleModal={toggleModal}
        toggleFilter={toggleFilter}
        handleSubmit={postAddMilestone}
        filterSubmit={filterMilestoneList}
        titleButton={`${milestoneData?.updateId ? "Edit" : "Add"} Level 1`}
        showButton={
          rolexModuleData?.find(
            (data) => pathname === data?.description && data?.create === 1
          )||
          roles?.find((data) => data?.role_id === 1001)
            ? true
            : false
        }
        AddUserContent={
          <Form className="modelform">
            <FormGroup>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="projectTitle">Level 0 *</Label>
                    <Select
                      classNamePrefix="react-select"
                      className="single-select"
                      menuPlacement="auto"
                      maxMenuHeight={200}
                      value={milestoneData?.projectTitle}
                      onChange={(select) => UserDataList(select)}
                      options={projectList}
                      // isMulti
                      // {...props}
                      isDisabled={
                        milestoneData?.updateId !== null ? true : false
                      }
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "rgba(2, 137, 255,.2)",
                          primary50: "rgba(2, 137, 255,.2)",
                          primary75: "rgba(2, 137, 255,.2)",
                          primary: "#0289ff",
                        },
                      })}
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="milestoneTitle">Level 1 Title *</Label>
                    <Input
                      type="text"
                      id="milestoneTitle"
                      name="milestoneTitle"
                      value={milestoneData?.milestoneTitle || ""}
                      isDisabled={(milestoneData?.updateId || milestoneData?.projectTitle?.projectStatus  === "Inactive")? true : false}
                      onChange={(e) =>
                        setMilestoneData({
                          ...milestoneData,
                          milestoneTitle: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="milestoneOwner">Team Members *</Label>
                    <Select
                      classNamePrefix="react-select"
                      className="multi-select"
                      menuPlacement="auto"
                      maxMenuHeight={200}
                      value={milestoneData?.milestoneOwner || ""}
                      onChange={(select) =>
                        setMilestoneData({
                          ...milestoneData,
                          milestoneOwner: select,
                        })
                      }
                      options={userDataList}
                      isMulti
                      isDisabled={(milestoneData?.projectTitle?.projectStatus  === "Inactive")? true : false}

                      // {...props}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "rgba(2, 137, 255,.2)",
                          primary50: "rgba(2, 137, 255,.2)",
                          primary75: "rgba(2, 137, 255,.2)",
                          primary: "#0289ff",
                        },
                      })}
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="milestoneOwner">
                      Level 1 Owner *
                    </Label>
                    <Select
                      classNamePrefix="react-select"
                      className="multi-select"
                      menuPlacement="auto"
                      maxMenuHeight={200}
                      value={milestoneData?.milestoneOwnerId || ''}
                      onChange={(select) => setMilestoneData({ ...milestoneData, milestoneOwnerId: select })}
                      options={milestoneData?.milestoneOwner}
                      isDisabled={(milestoneData?.projectTitle?.projectStatus  === "Inactive")? true : false}

                      theme={theme => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: 'rgba(2, 137, 255,.2)',
                          primary50: 'rgba(2, 137, 255,.2)',
                          primary75: 'rgba(2, 137, 255,.2)',
                          primary: '#0289ff',
                        }
                      })}
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="milestoneDesc">Description *</Label>
                    <Input
                      type="textarea"
                      id="milestoneDesc"
                      name="milestoneDesc"
                      value={milestoneData?.milestoneDesc || ""}
                      onChange={(e) =>
                        setMilestoneData({
                          ...milestoneData,
                          milestoneDesc: e.target.value,
                        })
                      }
                      isDisabled={(milestoneData?.projectTitle?.projectStatus  === "Inactive")? true : false}

                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="status">Status *</Label>
                    <Select
                      classNamePrefix="react-select"
                      className="single-select"
                      menuPlacement="top"
                      maxMenuHeight={200}
                      value={milestoneData?.milestoneStatus}
                      onChange={(select) =>
                        setMilestoneData({
                          ...milestoneData,
                          milestoneStatus: select,
                        })
                      }
                      options={milestoneStatusList}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "rgba(2, 137, 255,.2)",
                          primary50: "rgba(2, 137, 255,.2)",
                          primary75: "rgba(2, 137, 255,.2)",
                          primary: "#0289ff",
                        },
                      })}
                    />{" "}
                  </FormGroup>
                </Col> 
              </Row>
            </FormGroup>
          </Form>
        }
        userStatus={
          <ListInlineItem>
            <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
              <DropdownToggle className="activeuser" caret>
                {userStatus}
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={() => setUserStatus("Active")}>
                  Active
                </DropdownItem>
                <DropdownItem onClick={() => setUserStatus("Inactive")}>Inactive</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </ListInlineItem>
        }
        SlideBarContent={
          <Form className="modelform">
            <FormGroup>
              <Row>
                <Col md={12}>
                  <div className="resetFilterOption">
                    <a onClick={ClearFilter}>Clear Filter</a>
                  </div>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="projectTitle">Level 0 Title</Label>
                    <Input
                      type="text"
                      id="projectTitle"
                      name="projectTitle"
                      value={filterMilestone?.projectTitle || ""}
                      onChange={(e) =>
                        setFilterMilestone({
                          ...filterMilestone,
                          projectTitle: e.target.value,
                        })
                      }
                      disabled={
                        filterMilestone?.projectId?.length > 0 ? true : false
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="milestoneId">Level 1 ID/Title</Label>
                    <Input
                      type="text"
                      id="milestoneId"
                      name="milestoneId"
                      placeholder="Search by Level 1 ID or Title"
                      value={filterMilestone?.milestoneId || ""}
                      onChange={(e) =>
                        setFilterMilestone({
                          ...filterMilestone,
                          milestoneId: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="userRole">Created By</Label>
                    <Input
                      type="text"
                      id="createdBy"
                      name="createdBy"
                      value={filterMilestone?.createdBy || ""}
                      onChange={(e) =>
                        setFilterMilestone({
                          ...filterMilestone,
                          createdBy: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
              </Row>
            </FormGroup>
          </Form>
        }
      />
      <div id="milestones" className="contentInnerWrap">
        <div className="milestones-wrap">
          <div className="dropdown-wrap">
          {/* <div className="reloadData" style={{margin:10,color:"#199ec9" ,}}>
          <FaRedo onClick={getUserData} title="Refresh Data"  size={20}/>
        </div> */}
            {newProjectList?.length > 0 ? (
               newProjectList?.filter((data)=>  milestoneList?.find(
                (data1) =>
                  data1?.project_id === data?.value &&
                  (userStatus === "All"
                    ? data1
                    : data1?.milestone_status === userStatus)
              ))?.length > 0 ?
            (newProjectList?.filter((data)=>  milestoneList?.find(
                (data1) =>
                  data1?.project_id === data?.value &&
                  (userStatus === "All"
                    ? data1
                    : data1?.milestone_status === userStatus)
              ))?.map((data) => (
                <>
                  <div className="dropdown" onClick={()=> productsetIsOpen1(productisOpen1 === data?.value ? 0 : data?.value)}>
                    {productisOpen1 === data?.value ? (                 
                      <FaChevronDown />    
                    ) : (
                      <FaChevronRight />
                    )}
                    <span> <a onClick={() => navigate(`/project-detail?param1=${btoa(data?.value)}`)}>
                    {data?.label}
                          </a></span>
                    </div>
              


                  <div className="product-table">
                    <div
                      className={
                        productisOpen1 === data?.value
                          ? "product-list  productlist-open"
                          : "product-list "
                      }
                    >
                      {milestoneList?.length > 0 ? (
                        milestoneList?.filter(
                          (data1) =>
                            data1?.project_id === data?.value &&
                            (userStatus === "All"
                              ? data1
                              : data1?.milestone_status === userStatus)
                        )?.length > 0 ? (
                          <MDBTable align="middle" className="projectTable">
                            <MDBTableHead>
                            <tr key="header-row">
                                <th scope="col" style={{ minWidth: "420px" }}>
                                  Level 1
                                </th>
                                <th scope="col" className="text-center">
                                  Status
                                </th>
                                {/* <th scope='col' className="text-center">Owner</th> */}
                                <th
                                  scope="col"
                                  style={{
                                    minWidth: "220px",
                                    whiteSpace: "normal",
                                  }}
                                >
                                  Team Members
                                </th>
                                <th
                                  scope="col"
                                  style={{
                                    width: "200px",
                                    display: "inline-block",
                                    textAlign: "center",
                                  }}
                                >
                                  Tasks
                                </th>
                                <th scope="col">Created On</th>
                                <th scope="col">Created By</th>
                                <th scope="col">Modified On</th>
                                <th scope="col">Modified By</th>
                                  <th scope="col"> Action</th>
                              </tr>
                            </MDBTableHead>
                            <MDBTableBody>
                              {milestoneList
                                ?.filter(
                                  (data1) =>
                                    data1?.project_id === data?.value &&
                                    (userStatus === "All"
                                      ? data1
                                      : data1?.milestone_status === userStatus)
                                )
                                ?.map((data1) => (
                                  <tr  key={data1?.milestone_id} className="table-light">
                                    <th scope="row">
                                      <span className="assignedId">
                                        {serialSequence[1]?.prefix}-
                                        {data1?.milestone_code}
                                      </span>{" "}
                                      <NavLink
                                        className="d-inline-block ps-2"
                                        onClick={() => navigate("/task" +
                                        `?param1=${btoa(
                                          data1?.project_id
                                        )}&?param2=${btoa(
                                          data1?.milestone_id
                                        )}`)}
                                      >
                                        {data1?.milestone_title}
                                      </NavLink>{" "}
                                    </th>
                                    <td>
                                      <div
                                        className={
                                          "badge " +
                                          (data1?.milestone_status).replace(
                                            /\s/g,
                                            ""
                                          )
                                        }
                                      >
                                        {data1?.milestone_status}
                                      </div>
                                    </td>
                                    {/* <td>
                                      {data1?.milestone_owner&& data1?.milestone_owner?.[0]?.name || "-"}
                                  </td>  */}
                                    <HoverTooltip
                                      arrow
                                      top="true"
                                      title={
                                        data1?.milestone_x_owner?.length > 0
                                          ? data1?.milestone_x_owner
                                              .map((data) => data?.user_data?.[0]?.name)
                                              .sort((a, b) =>
                                                a.localeCompare(b)
                                              )
                                              .join(", ")
                                          : " - "
                                      }
                                    >
                                      <td
                                       style={{
                                        minWidth: "220px",
                                        maxWidth: "250px",
                                        WebkitLineClamp: "3",
                                        WebkitBoxOrient: "vertical", 
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                      >
                                        {data1?.milestone_x_owner?.length > 0
                                          ? data1?.milestone_x_owner
                                              .map((data) => data?.user_data?.[0]?.name)
                                              .sort((a, b) =>
                                                a.localeCompare(b)
                                              )
                                              .join(", ")
                                          : " - "}
                                      </td>
                                    </HoverTooltip>
                                    <td>
                                      <div className="progressBarWrap">
                                        <div className="closedStatus">
                                          {data1?.task_master?.filter(
                                            (data) =>
                                              (isSpecialAccess
                                                ? data
                                                : taskUserList?.includes(
                                                    data?.task_id
                                                  )) &&
                                                  (data?.task_status ===
                                                    "Completed" ||
                                                    data?.task_status ===
                                                      "Dropped")
                                          )?.length || "0"}
                                        </div>

                                        <HoverTooltip
                                          arrow
                                          top="true"
                                          title={
                                            <>
                                              {Math.round(
                                                (data1?.task_master?.filter(
                                                  (data) =>
                                                    data?.task_status ===
                                                      "Completed" &&
                                                    (isSpecialAccess
                                                      ? data
                                                      : taskUserList?.includes(
                                                          data?.task_id
                                                        ))
                                                )?.length /
                                                  data1?.task_master?.filter(
                                                    (data) =>
                                                    isSpecialAccess ? data
                                                        : taskUserList?.includes(
                                                            data?.task_id
                                                          )
                                                  )?.length) *
                                                  100
                                              ) || "0"}
                                              % (
                                              {data1?.task_master?.filter(
                                                (data) =>
                                                  (isSpecialAccess
                                                    ? data
                                                    : taskUserList?.includes(
                                                        data?.task_id
                                                      )) &&
                                                  data?.task_status ===
                                                    "Completed"
                                              )?.length || "0"}{" "}
                                              of{" "}
                                              {data1?.task_master?.filter(
                                                (data) =>
                                                isSpecialAccess ? data
                                                    : taskUserList?.includes(
                                                        data?.task_id
                                                      )
                                              )?.length || "0"}{" "}
                                              Task Completed )
                                            </>
                                          }
                                        >
                                          <div
                                            className="progress"
                                            style={{ height: "15px" }}
                                          >
                                            <div
                                              className="progress-bar bg-success"
                                              role="progressbar"
                                              style={{
                                                width:
                                                  data1?.task_master?.filter(
                                                    (data) =>
                                                    isSpecialAccess
                                                        ? data
                                                        : taskUserList?.includes(
                                                            data?.task_id
                                                          )
                                                  )?.length > 0
                                                    ? Math.round(
                                                        (data1?.task_master?.filter(
                                                          (data) =>
                                                            data?.task_status ===
                                                              "Completed" &&
                                                            (isSpecialAccess
                                                              ? data
                                                              : taskUserList?.includes(
                                                                  data?.task_id
                                                                ))
                                                        )?.length /
                                                          data1?.task_master?.filter(
                                                            (data) =>
                                                            isSpecialAccess ? data
                                                                : taskUserList?.includes(
                                                                    data?.task_id
                                                                  )
                                                          )?.length) *
                                                          100
                                                      ) + "%"
                                                    : "0%",
                                              }}
                                              aria-valuenow="25"
                                              aria-valuemin="0"
                                              aria-valuemax="100"
                                            >
                                              &nbsp;
                                            </div>
                                            <div
                                              className={`percentageText ${
                                                Math.round(
                                                  (data1?.task_master?.filter(
                                                    (data) =>
                                                      data?.task_status ===
                                                        "Completed" &&
                                                      (isSpecialAccess
                                                        ? data
                                                        : taskUserList?.includes(
                                                            data?.task_id
                                                          ))
                                                  )?.length /
                                                    data1?.task_master?.filter(
                                                      (data) =>
                                                      isSpecialAccess
                                                          ? data
                                                          : taskUserList?.includes(
                                                              data?.task_id
                                                            )
                                                    )?.length) *
                                                    100
                                                ) > 50
                                                  ? "text-white"
                                                  : ""
                                              }`}
                                            >
                                              {data1?.task_master?.filter(
                                                (data) =>
                                                isSpecialAccess                                                    ? data
                                                    : taskUserList?.includes(
                                                        data?.task_id
                                                      )
                                              )?.length > 0
                                                ? Math.round(
                                                    (data1?.task_master?.filter(
                                                      (data) =>
                                                        data?.task_status ===
                                                          "Completed" &&
                                                        (isSpecialAccess
                                                          ? data
                                                          : taskUserList?.includes(
                                                              data?.task_id
                                                            ))
                                                    )?.length /
                                                      data1?.task_master?.filter(
                                                        (data) =>
                                                        isSpecialAccess
                                                            ? data
                                                            : taskUserList?.includes(
                                                                data?.task_id
                                                              )
                                                      )?.length) *
                                                      100
                                                  ) + "%"
                                                : "0%"}
                                            </div>
                                          </div>
                                        </HoverTooltip>

                                        <div className="openStatus">
                                          {data1?.task_master?.filter(
                                            (data) =>
                                              (isSpecialAccess
                                                ? data
                                                : taskUserList?.includes(
                                                    data?.task_id
                                                  )) &&
                                              !(
                                                data?.task_status ===
                                                "Completed"
                                              )
                                          )?.length || "0"}
                                        </div>
                                      </div>
                                    </td>
                                   <td>
                                      {new Date(
                                        data1?.createdDate.split(" ")?.[0]
                                      ).toLocaleDateString("en-TT")}
                                    </td>
                                    <td>
                                      {data1?.created_user?.length > 0
                                        ? data1?.created_user?.[0]?.name
                                        : "-"}
                                    </td>
                                    <td>
                                      {new Date(
                                        data1?.updatedDate.split(" ")?.[0]
                                      ).toLocaleDateString("en-TT")}
                                    </td>
                                    <td>
                                      {data1?.updated_user?.length > 0
                                        ? data1?.updated_user?.[0]?.name
                                        : "-"}
                                    </td>
                                    {rolexModuleData?.find(
                                      (data) =>
                                        pathname === data?.description &&
                                        data?.update === 1
                                    ) ||
                                    roles?.find(
                                      (data) => data?.role_id === 1001
                                    )? (
                                      <td
                                        onClick={() =>
                                          UptMilestone(data1?.milestone_id)
                                        }
                                      >
                                        <MDBBtn
                                          color="link"
                                          rounded
                                          size="sm"
                                          className="actionBtn"
                                        >
                                          <FaEdit />
                                        </MDBBtn>
                                      </td>
                                    ) : <td>-</td>}
                                  </tr>
                                ))}
                            </MDBTableBody>
                          </MDBTable>
                        ) : (
                          <div className="defaultPlaceholder">
                            <img src={projectPlaceholderImg} alt="No Project" />
                            <h4 className="defaultPlaceholderText">
                              There are no records under "{userStatus}"
                              status!
                            </h4>
                          </div>
                        )
                      ) : (
                        <div className="defaultPlaceholder">
                          <img src={projectPlaceholderImg} alt="No Project" />
                          <h4 className="defaultPlaceholderText">
                            There are no records!
                          </h4>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              ))) : (
                <div className="defaultPlaceholder">
                <img src={projectPlaceholderImg} alt="No Project" />
                <h4 className="defaultPlaceholderText">
                There are no records under "{userStatus}" status!
                </h4>
              </div>
              )
            ) : (
              <div className="defaultPlaceholder">
                <img src={projectPlaceholderImg} alt="No Project" />
                <h4 className="defaultPlaceholderText">
                  There are no records!
                </h4>
              </div>
            )}
          </div>
        </div>
      </div>
    </>)
  );
}

export default Milestones;
